<template>
	<div style="width: 100%; height: 100%">
		<div
			style="width: 100%; height: 100%"
			v-if="loading"
			v-loading="loading"
			element-loading-text="正在跳转"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255)"
		></div>
		<div class="img flex-center pos-rela" v-else>
			<div class="pos-abso" style="top: 28px; left: 28px">
				<img style="height: 40px" src="@/assets/public/i-logo-partner.png" alt="" />
			</div>
			<div v-if="!inviteData.checkPwd && loginStatus">
				<div>
					<span class="font-h1-medium yx-color-text-primary" style="font-size: 24px">协作绑定</span>
					<span class="ml-12 yx-color-text-secondary font-h6-regular">绑定后即可协同样品订单</span>
				</div>
				<div class="pos-rela">
					<div
						class="yx-background-white pt-16 pb-16 pl-12 pr-12 font-h4-regular yx-color-text-primary radius-4"
						style="width: 408px; margin-top: 40px"
					>
						{{ inviteData.tenantName || '-' }}
					</div>
					<div class="pos-abso" style="top: 50px; left: 210px; z-index: 999">
						<img style="width: 40px; height: 40px" src="@/assets/public/icon-partner-img.png" alt="" />
					</div>
					<div
						class="pos-rela flex-row-align-center flex-just-between yx-background-white pt-16 pb-16 pl-12 pr-12 font-h4-regular yx-color-text-primary radius-4"
						style="width: 408px; margin-top: 20px"
					>
						<img class="pos-abso" style="width: 64px; top: -14px; right: 0px" src="@/assets/public/now-team-img.png" alt="" />
						<span>{{ vuex_userInfo.team_name }}</span>
						<span class="yx-color-primary cursor-pointer" v-if="tenantInfoList.length > 1" @click="switchTenant">切换团队</span>
					</div>
				</div>
				<div class="radius-12 p-24 yx-background-white" style="margin-top: 40px">
					<p class="font-h4-regular yx-color-text-regular">绑定后将与商家绑定协作关系，商家将获取您的以下信息：</p>
					<div class="mt-16 flex-row-align-center">
						<yx-avatar :size="40" :src="vuex_userInfo.avatar_url" class="mr-8"></yx-avatar>
						<div>
							<p class="yx-color-text-primary font-h6-medium">{{ vuex_userInfo.nick_name }}</p>
							<p class="yx-color-text-secondary font-h6-medium">手机号：{{ vuex_userInfo.mobile }}</p>
						</div>
					</div>
				</div>
				<div style="margin-top: 40px">
					<el-button style="width: 280px" type="primary" :loading="bindLoading" @click="goBind">去绑定</el-button>
					<el-button style="width: 136px" class="ml-24" @click="skipRegister">注册</el-button>
				</div>
			</div>
			<div v-if="!inviteData.checkPwd && !loginStatus">
				<p class="font-h1-medium" style="font-size: 24px">
					<span class="yx-color-primary mr-4">{{ inviteData.tenantName || '-' }}</span>
					<span class="yx-color-text-primary">邀请</span>
					<span class="yx-color-primary ml-4 mr-4">{{ inviteData.organizationName || '-' }}</span>
					<span class="ml-4">协作样品</span>
				</p>
				<div style="margin-top: 40px">
					<p class="font-h2-medium yx-color-text-primary">协作样品规则:</p>
					<p class="mt-16 font-h3-regular" v-if="inviteData.ruleAnchorShow">
						<span class="yx-color-danger">*</span>
						<span class="yx-color-text-regular">协作样品订单达人信息包含{{ inviteData.ruleAnchorShow }}</span>
					</p>
					<p class="mt-16 font-h3-regular" v-if="inviteData.ruleCooperateMethod">
						<span class="yx-color-danger">*</span>
						<span class="yx-color-text-regular">协作样品订单需商家{{ inviteData.ruleCooperateMethod }}</span>
					</p>
					<p style="margin-top: 40px">
						<el-button style="width: 280px" type="primary" @click="goLogin">登录/注册</el-button>
					</p>
					<p class="font-h6-regular yx-color-text-secondary mt-12">登录/注册则视为同意上述条款并与团长成为样品协作者</p>
				</div>
			</div>
			<div class="text-align-center" v-if="inviteData.checkPwd">
				<p class="yx-color-text-primary font-h1-medium" style="margin-bottom: 30px; font-size: 24px">请输入密码访问</p>
				<el-input v-model="pwd" style="width: 280px" placeholder="请输入" />
				<p class="mt-20">
					<el-button type="primary" style="width: 280px" @click="confirmPwd">确认</el-button>
				</p>
			</div>
			<sampleTipsDialog ref="sampleTipsDialog" />
			<drTipsDialog ref="drTipsDialog" />
			<tipsDialog ref="tipsDialog" />
			<ChooseGroup ref="chooseGroup" :tenantInfoList="tenantInfoList" @choose="chooseGroup" :showClose="false"></ChooseGroup>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import { cooperateLinkCheck, cooperateLinkCheckPwd, doCooperateBind, accountInfo, checkBindCooperativeShop } from '@/api/common';
import { confirmLogin } from '@/api/user';
import * as types from '@/store/mutation-types';
import sampleTipsDialog from './sampleTipsDialog.vue';
import drTipsDialog from './drTipsDialog.vue';
import tipsDialog from './tipsDialog.vue';
import mixin from '@/views/user/mixin';
import { getTenantList } from '@/api/businessGroup';
import ChooseGroup from '@/components/business/chooseTenant';
export default {
	components: {
		sampleTipsDialog,
		drTipsDialog,
		tipsDialog,
		ChooseGroup,
	},
	mixins: [mixin],
	computed: {
		...mapState(['loginStatus', 'vuex_userInfo', 'vuex_inviteData', 'vuex_userId']),
	},
	data() {
		return {
			linkId: '',
			pwd: '',
			inviteData: {
				checkPwd: 0,
				tenantName: '',
				organizationName: '',
				ruleCooperateMethod: '',
				ruleAnchorShow: '',
			},
			loading: true,
			bindLoading: false,
			tenantInfoList: [],
		};
	},
	created() {
		this.linkId = this.$route.query.linkId;
		if (this.$route.query.isLogin) {
			this.inviteData = this.vuex_inviteData;
			console.log('this.vuex_inviteData', this.vuex_inviteData);

			this.loading = false;
		} else {
			this.cooperateLinkCheck();
		}
		if (this.loginStatus) {
			this.getTenant();
		}
		this.loadBindCooperativeShop();
	},
	methods: {
		async cooperateLinkCheck() {
			this.loading = true;
			const data = await cooperateLinkCheck({ linkId: this.linkId });
			this.inviteData = data;
			this.$store.commit(types.INVITE_DATA, data);
			this.loading = false;
		},
		async confirmPwd() {
			const data = await cooperateLinkCheckPwd({ linkId: this.linkId, pwd: this.pwd });
			this.inviteData = data;
			this.$store.commit(types.INVITE_DATA, data);
			this.inviteData.checkPwd = 0;
		},
		async getTenant() {
			const { tenantInfoList } = await getTenantList({ userId: this.vuex_userId });
			this.tenantInfoList = tenantInfoList;
		},
		async switchTenant() {
			this.$refs.chooseGroup.show();
		},

		async chooseGroup({ userId, tenantId, preAuthSign } = {}) {
			const {
				code,
				data: { accessToken, roleList },
			} = await confirmLogin({ userId, tenantId, preAuthSign });
			if (code === 0) {
				this.handleTenantLogin({ accessToken, tenantId, roleList, userId });
				this.$refs.chooseGroup.hide();
			}
		},
		async handleTenantLogin({ accessToken, tenantId, roleList, userId }) {
			await this.setData(accessToken, tenantId, roleList, userId);
			// 获取php用户信息
			const { code, data } = await accountInfo({});
			if (code == 0) {
				// 更新配置字段
				this.$store.commit(types.USER_INFO, data);
			}
			this.loadBindCooperativeShop();
		},
		setData(token, tenantId, roleList = [], userId) {
			return new Promise(async (rs, rj) => {
				try {
					// 保存token到cookie
					CookiesTools.setToken(token);
					// 设置登录态
					this.$store.commit(types.LOGIN_STATUS, true);
					this.$store.commit(types.TENANT_ID, tenantId);
					this.$store.commit(types.USER_ID, userId);
					this.$store.commit(types.BIND_ROLES, roleList);
					rs();
				} catch (error) {
					rj();
				}
			});
		},
		goLogin() {
			this.$router.push({
				path: '/login',
				query: {
					linkId: this.linkId,
				},
			});
		},
		async goBind() {
			this.bindLoading = true;
			try {
				const { rule = 0, sampleRule = true, cooperateRule = true, dataAuthorityRule = true } = await doCooperateBind({ linkId: this.linkId });
				if (!rule) {
					this.$message.success('绑定成功');
					const openIds = this.tenantInfoList.find(item => item.tenantName === this.vuex_userInfo.team_name)?.openIds || [];
					// 回到工作台页面
					this.gotoGoods(openIds);
				}
				if (rule === 1) {
					this.$refs.sampleTipsDialog.show(sampleRule, cooperateRule);
				}
				if (rule === 2) {
					this.$refs.drTipsDialog.show(dataAuthorityRule);
				}
				if (rule === 3) {
					this.$refs.tipsDialog.show();
				}
			} finally {
				this.bindLoading = false;
			}
		},
		skipRegister() {
			this.$router.push({
				path: '/register',
				query: {
					linkId: this.linkId,
				},
			});
		},
		async loadBindCooperativeShop() {
			if (this.loginStatus) {
				const res = await checkBindCooperativeShop({ linkId: this.linkId });
				if (res.bindStatus) {
					this.$router.replace('/shopManage/shopLibrary/list');
				}
			}
		},
	},
};
</script>
<style lang="less" scoped>
.img {
	width: 100%;
	height: 100%;
	background-image: url('https://cdn.chaoyongbushou.com/wx/20250217/1739784992699-invite-password-img.png');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
}
/deep/ .el-input__inner {
	height: 48px;
}
</style>
